<template>
<div class="page-wrapper">
<i v-if="isPopupCloseBackIcon" class="back-icon" @click="$router.back()"></i>
   <CustomHeader :text="$t('profile.configuration')" />
    <div class="avatar_container">
        <div class="profileImg">
            <img :src="dataSet?.avatarImg || defaultAvatar" alt="">
        </div>

        <van-uploader class="uploader" :after-read="afterRead">
            <MainButton :title="$t('profile.choosePhoto')" :activeStatus="true" />
        </van-uploader>
    </div>
    </div>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import CustomHeader from '../components/common/customHeader.vue';
import MainButton from '../components/common/mainButton.vue';
import { AvatarData } from '@/view/profile/supportScript';
import defaultAvatar from '@/assets/themeFour/defaultAvatar.jpg';

const props = defineProps<{
    dataSet: AvatarData
}>()

const isPopupCloseBackIcon = ref(true)


const emits = defineEmits(['afterRead'])

const afterRead = (file: any) => {
   emits('afterRead', file)
};

</script>
<style scoped>
.page-wrapper {
  background-color: #003534;
  min-height: 100vh
}

.avatar_container {
    padding: 70px 25px;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
}

.profileImg {
    min-width: 300px;
    min-height: 300px;
}

.avatar_container img {
    width: 300px;
    border-radius: 60px;
}

.uploader {
    margin-top: 25px;
}
</style>